// Public booking pages are visited by guests who are never "logged in" as a
// company owner — auth-based redirects must never bounce them away from
// these paths.
export const isPublicBookingRoute = (path: string) =>
  path.startsWith("/company/") || path.startsWith("/verify-email/") || path.startsWith("/account/bookings");
